import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Configurazione } from '../../../../shared/interface';

@Component({
  selector: 'app-modifica-configurazione-backoffice',
  templateUrl: './modifica-configurazione-backoffice.component.html',
  styleUrl: './modifica-configurazione-backoffice.component.css'
})
export class ModificaConfigurazioneBackofficeComponent implements OnInit {

  @ViewChild("confirmDeletePopupRef") confirmPopup!: ConfirmPopup;

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService) { }  

  formConfigurazione!: FormGroup;  

  configurazione?: Configurazione;

  ngOnInit(): void {    

    this.formConfigurazione = new FormGroup({
      value: new FormControl(null, Validators.required),      
      descrizione: new FormControl(null),        
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getConfigurazione(id).subscribe({
        next: (data) => this.configurazione = data,
        error: (err) => this.router.navigate(['/backoffice/configurazioni']),
        complete: () => {

          this.formConfigurazione.patchValue({
            value: this.configurazione?.value,            
            descrizione: this.configurazione?.descrizione,            
          })

        }
      })

    })
  }

  onDeleteConfigurazionePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare la configurazione?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteConfigurazione(this.configurazione!.id).subscribe({
          next: (data) => this.apiService.setConfigurazioni(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/configurazioni']);
            this.apiService.message("success", "Eliminazione", "La configurazione è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  /** Inizio/fine stagione: salva sempre dd/MM/yyyy. */
  get isStagioneDateConfig(): boolean {
    const d = (this.configurazione?.descrizione || this.formConfigurazione?.get('descrizione')?.value || '').toLowerCase();
    return /stagione/.test(d) && /(inizio|fine)/.test(d);
  }

  /** Normalizza a dd/MM/yyyy (accetta anche YYYY-MM-DD e legacy MM/dd se non ambiguo). */
  private normalizeStagioneDate(value: string): string | null {
    const s = String(value || '').trim();
    const iso = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s);
    if (iso) {
      const d = String(iso[3]).padStart(2, '0');
      const m = String(iso[2]).padStart(2, '0');
      return `${d}/${m}/${iso[1]}`;
    }
    const parts = /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/.exec(s);
    if (!parts) return null;
    const a = Number(parts[1]);
    const b = Number(parts[2]);
    const y = parts[3];
    let day: number;
    let month: number;
    if (a > 12 && b <= 12) { day = a; month = b; }
    else if (b > 12 && a <= 12) { month = a; day = b; }
    else { day = a; month = b; }
    return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${y}`;
  }

  onSubmit() {
    let value = this.formConfigurazione.get('value')?.value;
    if (this.isStagioneDateConfig) {
      const normalized = this.normalizeStagioneDate(value);
      if (!normalized) {
        this.apiService.message('error', 'Errore', 'Data non valida: usa dd/MM/yyyy (es. 01/10/2025)');
        return;
      }
      value = normalized;
    }

    const configurazione = {
      value,
      descrizione: this.formConfigurazione.get('descrizione')?.value
    }

    this.apiService.updateConfigurazione(configurazione, this.configurazione!.id).subscribe({
      next: (data) => this.apiService.setConfigurazioni(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/configurazioni'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }


}
